goog.provide("shadow.js.shim.module$$js_temporal$polyfill$Temporal_Instant");
shadow.js.shim.module$$js_temporal$polyfill$Temporal_Instant = shadow.js.require(1, {})["Temporal"]["Instant"];
